import { required, minValue, decimal } from 'vuelidate/lib/validators'
import { getFirstErrorMessage, getErrorMessagesWithKeys } from '~/lib/axios'
import axios from 'axios'

const EventBus = window.VueEventBus

export default {

  data: () => ({
    giftcard: {
      number: '',
      cvv: '',
      amount: '',
      options: {
        number: null,
        cvv: null,
        amount: null,
      },
      isPartial: false,
      isAdding: false,
      error: null,
      errorType: null,
    },
  }),

  validations: {
    giftcard: {
      number: {
        required,
      },
      cvv: {
        required,
      },
      amount: {
        required,
        decimal,
        minValue: minValue(0.01),
        maxDecimals: v => ((Number(v).toFixed(2) - v) === 0),
      },
    },
    giftcardApplyGroup: [
      'giftcard.number', 'giftcard.cvv',
    ],
  },

  methods: {
    async addGiftcard() {
      if (this.costDetails.discounts.data.some(x => x.type === 'giftcard' && x.options.number === this.giftcard.number)) {
        this.giftcard.error = 'This gift card is already added'
        this.giftcard.errorType = 'number'
      } else {
        try {
          this.giftcard.isAdding = true

          this.giftcard.options = {
            number: this.giftcard.number,
            cvv: this.giftcard.cvv,
          }

          const { data: { data: giftcard } } = await axios.post(`${window.addiesaas.url}/api/customer/giftcard/check`, this.giftcard.options)

          this.giftcard.amount = this.giftcard.options.amount = Number(giftcard.balance)

          this.giftcard.error = null
          this.giftcard.errorType = null

          this.showGiftcardFullPartialModal = true
        } catch (e) {
          const errors = getErrorMessagesWithKeys(e)
          const errorKeys = Object.keys(errors)|| []
          this.giftcard.error = getFirstErrorMessage(e)
          this.giftcard.errorType = errorKeys[0] || 'number'
        } finally {
          this.giftcard.isAdding = false
        }
      }
    },

    applyGiftcard(amount) {
      this.showGiftcardFullPartialModal = false
      const id = `giftcard_${this.giftcard.number}`

      if (amount !== null) {
        amount = Number(amount)

        if (id in this.cartDiscounts) {
          amount += this.cartDiscounts[id].payload.options.amount
        }

        if (amount > this.giftcard.options.amount) {
          this.giftcard.error = 'The selected amount is not available on your Gift Card'
          this.giftcard.errorType = 'amount'
          return
        }

        this.giftcard.options.amount = amount
      }

      const discount = {
        id,
        title: this.giftcard.number,
        type: 'giftcard',
        payload: {
          type: 'giftcard',
          options: this.giftcard.options
        },
      }
      this.addDiscount(discount)

      this.giftcard.number = this.giftcard.cvv = null
      this.giftcard.options = {}
      if (this.onGiftcardAdded) {
        this.onGiftcardAdded(discount)
      }
      this.showGiftcardAmountModal = false
      EventBus.$emit('cart.validate')
    },

    giftcards(summary) {
      return Object
        .values(this.cartDiscounts)
        .filter(x => x.type === 'giftcard')
        .map(x => {
          const discount = summary ?
            summary.discounts.data.find(y => y.type === 'giftcard' && y.options.number === x.payload.options.number) || {} : {}
          return Object.assign({}, x, { discount })
        })
    },

    giftcardsDiscount(summary) {
      if (summary) {
        return summary.discounts.data
          .filter(x => x.type === 'giftcard')
          .map(x => -(x.price_discount + (x.tax_discount || 0) + (x.fee_discount || 0)))
          .reduce((total, x) => total + x, 0)
      }
    },

    deleteGiftcard(id) {
      this.removeCartDiscount({ id })
      EventBus.$emit('cart.validate')
    },
  },
}
